/*kiwi/build/strength*/
function _(require, module, exports) {
    var Strength;
    (function (Strength) {
        /**
     * Create a new symbolic strength.
     */
        function create(a, b, c, w) {
            if (w === void 0) {
                w = 1;
            }
            var result = 0;
            result += Math.max(0, Math.min(1000, a * w)) * 1000000;
            result += Math.max(0, Math.min(1000, b * w)) * 1000;
            result += Math.max(0, Math.min(1000, c * w));
            return result;
        }
        Strength.create = create;
        /**
     * The 'required' symbolic strength.
     */
        Strength.required = create(1000, 1000, 1000);
        /**
     * The 'strong' symbolic strength.
     */
        Strength.strong = create(1, 0, 0);
        /**
     * The 'medium' symbolic strength.
     */
        Strength.medium = create(0, 1, 0);
        /**
     * The 'weak' symbolic strength.
     */
        Strength.weak = create(0, 0, 1);
        /**
     * Clip a symbolic strength to the allowed min and max.
     */
        function clip(value) {
            return Math.max(0, Math.min(Strength.required, value));
        }
        Strength.clip = clip;
    }(Strength = exports.Strength || (exports.Strength = {})));
}